import { HStack } from '@chakra-ui/react';

import { Badge } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { getTimeLabel } from 'features/sessions/utils';

import { Typography } from 'shared/components/Typography';

type CoachSessionsTimeProps = {
  startTime: string;
  endTime: string;
};

export const CoachSessionsTime = ({
  startTime,
  endTime,
}: CoachSessionsTimeProps) => (
  <HStack gap={1}>
    <HStack>
      <Icon name={iconNames.clock} width="16px" height="16px" />
      <Typography
        type="meta"
        color="black"
        data-testid="sidebar-session-start-time"
      >
        {dateUtils.localDate(startTime).format('h:mm A')}
      </Typography>
      <Typography type="meta" color="black">
        -
      </Typography>
      <Typography
        type="meta"
        color="black"
        data-testid="sidebar-session-end-time"
      >
        {dateUtils.localDate(endTime).format('h:mm A')}
      </Typography>
    </HStack>
    <Badge
      colorPalette="darkGray"
      size="xs"
      data-testid="sidebar-session-duration-badge"
    >
      <Typography color="white" type="small">
        {getTimeLabel(startTime, endTime)}
      </Typography>
    </Badge>
  </HStack>
);
